export enum ManureCategory {
  slurry = 'Slurry',
  solid = 'Solid',
  biological = 'Biological',
  other = 'Other',
}
